import { isDev } from "./environment";
export const VIEWED_PRODUCT = "Viewed Product";
export const PLACED_ORDER = "Placed Order";
export const cvgTrack = (args) => {
    if (typeof window === "undefined") {
        console.log("COULDNT FIND WINDOW");
        return;
    }
    // @ts-ignore
    let { cvg } = window;
    if (!cvg) {
        // @ts-ignore
        // eslint-disable-next-line
        cvg = window["cvg"] = function (...args) {
            cvg.queue = cvg.queue || [];
            if (cvg.process)
                cvg.process.bind(cvg)(...args);
            else
                cvg.queue.push(args);
        };
    }
    try {
        cvg({ method: "track", ...args });
    }
    catch (e) {
        // do nothing
        if (isDev) {
            console.error(e);
        }
    }
};
export const cvgForward = (args) => {
    if (typeof window === "undefined") {
        return;
    }
    // @ts-ignore
    let { cvg } = window;
    if (!cvg) {
        // @ts-ignore
        // eslint-disable-next-line
        cvg = window["cvg"] = function (...args) {
            cvg.queue = cvg.queue || [];
            if (cvg.process)
                cvg.process.bind(cvg)(...args);
            else
                cvg.queue.push(args);
        };
    }
    cvg({ method: "forward", ...args });
};
